export const SITE_URL = 'https://bociany.zywocice.pl';

const DEFAULT_STREAM_HLS_URL = 'https://cam.lokalna.net/hls/bociany_zywocice/index.m3u8';

/** Np. własny proxy z rozmyciem: REACT_APP_STREAM_HLS_URL=https://…/hls/index.m3u8 */
export const STREAM_HLS_URL =
    (process.env.REACT_APP_STREAM_HLS_URL || '').trim() || DEFAULT_STREAM_HLS_URL;

export const WEATHER_LAT = 50.204;
export const WEATHER_LON = 18.061;

function publicJsonPath(filename, envOverride) {
    const fromEnv = (process.env[envOverride] || '').trim();
    if (fromEnv) return fromEnv;
    const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
    return `${base}/${filename}`;
}

export function getKalendariumJsonUrl() {
    return publicJsonPath('kalendarium.json', 'REACT_APP_KALENDARIUM_URL');
}

export function getNestJsonUrl() {
    return publicJsonPath('nest.json', 'REACT_APP_NEST_URL');
}
